<script>
  import { tick } from 'svelte'

  let { className = '', children } = $props()
  let collapsed = $state(false)
  let buttonElem = $state()
  let buttonLastTop = 0

  let isCollapsibleSection = $derived(className?.indexOf('collapsible') === 0)

  const getSectionInfos = () => {
    const regex = /^collapsible(?:-(\d+))?(?:-([0-9a-zA-Z-]+))?(?:_([0-9a-zA-Z]+))?$/
    const match = className?.trim().match(regex)
    let cutoff = 3
    let anchor = null
    if (match) {
      const [, cutoffVal, anchorVal] = match
      cutoff = cutoffVal ?? cutoff
      anchor = anchorVal ?? anchor
    }
    return { cutoff, anchor }
  }

  const toggleCollapsible = async () => {
    collapsed = !collapsed

    if (!collapsed) {
      buttonLastTop = buttonElem.getBoundingClientRect().top
    }

    await tick()
    window.dispatchEvent(new Event('resize'))

    if (!collapsed) {
      const buttonNewTop = buttonElem.getBoundingClientRect().top

      if (buttonLastTop !== buttonNewTop) {
        const delta = buttonNewTop - buttonLastTop
        window.scrollBy({ top: delta, behavior: 'instant' })
      }
    }
  }
</script>

{#if isCollapsibleSection}
  {@const { cutoff, anchor } = getSectionInfos()}
  {@const collapseButtonID = anchor ? `${anchor}-collapse-button` : ''}
  <div
    id={anchor}
    class="collapsible-container cutoff-{cutoff}"
    data-collapsed={collapsed}
    aria-owns={collapseButtonID}
  >
    {@render children?.()}

    <button
      bind:this={buttonElem}
      id={collapseButtonID}
      aria-expanded={collapsed}
      aria-controls={anchor}
      onclick={toggleCollapsible}>Show {collapsed ? 'less' : 'more'}</button
    >
  </div>
{:else}
  {@render children?.()}
{/if}

<style lang="scss">
  @mixin set-cutoff($cutoff) {
    .collapsible-container.cutoff-#{$cutoff} .block:nth-child(n + #{$cutoff + 1}) {
      display: none;
    }
  }

  .collapsible-container {
    position: relative;
    padding-bottom: 4rem;

    &[data-collapsed='false']::before {
      content: '';
      position: absolute;
      bottom: 100px;
      left: 0;
      width: 100%;
      height: 300px;
      max-height: calc(100% - 100px);
      background: linear-gradient(transparent, var(--body-background-color));
      pointer-events: none;
    }

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 100%;
      max-width: 400px;
      height: 1px;
      background-color: var(--border-color, unset);
    }

    button {
      display: block;
      padding: 5px 15px;
      font-size: px-to-rem(15);
      font-family: var(--font-sans-serif);
      border: 1px solid var(--border-color, unset);
      border-radius: 23px;
      margin: 0 auto;
      margin-top: 30px;
    }
  }

  :global {
    @for $i from 1 to 10 {
      @include set-cutoff(($i));
    }

    .collapsible-container[data-collapsed='true'] .block:nth-child(n) {
      display: block;

      &::after {
        display: none;
      }
    }

    section[class*='_curator'] .paragraph {
      font-family: var(--font-sans-serif);
      font-size: px-to-rem(16);
    }
  }
</style>
